module.exports = __webpack_public_path__ + "img/min_yuan1.d1112573.png";